/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';

import Modal, { ModalHeader, ModalFooter } from '../../../../components/Modal';
import Button from '../../../../components/Button';
import ServiceSeverityGrid from '../ServiceSeverityGrid';

import './style.css';

class EditInstanceSubscriptionModal extends React.Component {
  componentDidMount() {
    const { instances, instanceSubscription } = this.props;
    const instance = instances.find(i => {
      return i.key === instanceSubscription[0].instanceKey;
    });

    const serviceList = {};
    const emailSub = instanceSubscription.find(i => {
      return i.subType === 'email';
    });
    const smsSub = instanceSubscription.find(i => {
      return i.subType === 'sms';
    });

    if (!emailSub) {
      serviceList.email = instance.Services.map(service => {
        return {
          serviceKey: service.key,
          major: false,
          minor: false,
          maintenance: false,
        };
      });
    } else if (instance && emailSub.allNotifications) {
      serviceList.email = instance.Services.map(service => {
        return {
          serviceKey: service.key,
          major: true,
          minor: true,
          maintenance: true,
        };
      });
    } else if (instance && emailSub) {
      // If Instance is active, populate grid with current Instance's Services and values from Instance Subscription
      // default to null
      serviceList.email = instance.Services.map(service => {
        const serviceSubscription = emailSub.ServiceSubscriptions.find(ss => {
          return ss.serviceKey === service.key;
        });

        const a = serviceSubscription || {
          serviceKey: service.key,
          major: false,
          minor: false,
          maintenance: false,
        };
        return a;
      });
    }
    if (!smsSub) {
      serviceList.sms = instance.Services.map(service => {
        return {
          serviceKey: service.key,
          major: false,
          minor: false,
          maintenance: false,
        };
      });
    } else if (instance && smsSub.allNotifications) {
      serviceList.sms = instance.Services.map(service => {
        return {
          serviceKey: service.key,
          major: true,
          minor: true,
          maintenance: true,
        };
      });
    } else if (instance && smsSub) {
      // If Instance is active, populate grid with current Instance's Services and values from Instance Subscription
      // default to null
      serviceList.sms = instance.Services.map(service => {
        const serviceSubscription = smsSub.ServiceSubscriptions.find(ss => {
          return ss.serviceKey === service.key;
        });

        const a = serviceSubscription || {
          serviceKey: service.key,
          major: false,
          minor: false,
          maintenance: false,
        };
        return a;
      });
    } 
    this.props.serviceSeverityGrid.actions.load(serviceList);
  }

  submit = () => {
    const {
      services,
      allCheckedEmail,
      allIndeterminateEmail,
      servicesSMS,
      allCheckedSMS,
      allIndeterminateSMS,
    } = this.props.serviceSeverityGrid.state;
    const emailSubPayload = {
      type: 'INSTANCE',
      allNotifications: allCheckedEmail,
      subType: 'email',
      ServiceSubscriptions: allIndeterminateEmail ? services : [],
    };

    const smsSubPayload = {
      type: 'INSTANCE',
      allNotifications: allCheckedSMS,
      subType: 'sms',
      ServiceSubscriptions: allIndeterminateSMS ? servicesSMS : [],
    };
    const { patchEmailSubscription, patchSMSSubscription, postSubscription } = this.props.requests;
    const { instanceSubscription } = this.props;
    const shouldPatch = instanceSubscription.some(sub => sub.subType === 'sms');
    Promise.all([
      patchEmailSubscription.handleRequest({ body: emailSubPayload }),
      shouldPatch
        ? patchSMSSubscription.handleRequest({ body: smsSubPayload })
        : postSubscription.handleRequest({
          body: { ...smsSubPayload, instanceKey: instanceSubscription[0].instanceKey },
        }),
    ])
      .then(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('success', 'Your subscription has been successfully edited!');
      })
      .catch(() => {
        this.props.requests.subscriber.handleRequest();
        this.props.onClose('failure', 'There was an error. Please try again');
      });
  };

  render() {
    return (
      <Modal onClose={this.props.onClose}>
        <ModalHeader text="Edit Subscription" />
        <div className="body-wrapper">
          <ServiceSeverityGrid
            serviceSeverityGrid={this.props.serviceSeverityGrid}
            closeModal={this.props.onClose}
            requests={this.props.requests}
          />
        </div>
        <ModalFooter>
          <Button onClick={this.props.onClose}>Close</Button>
          <Button theme="brand" onClick={this.submit}>
            Submit
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditInstanceSubscriptionModal;
